(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../icon", "../_util/raf"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../icon"), require("../_util/raf"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.icon, global.raf);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _icon, _raf) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _icon = _interopRequireDefault(_icon);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('transition', {
        attrs: {
          "name": _vm.checkModel() ? 'notice-bar-show-fade' : 'notice-bar-fade'
        }
      }, [_vm.isShow ? _c('div', {
        staticClass: "nx-notice-bar",
        class: [_vm.align, _vm.type, _vm.overflow && _vm.scrollable ? 'scrollable' : '', _vm.overflow && _vm.scrollable && _vm.mode ? 'scrollable-mode' : '', _vm.checkModel() ? 'model-overflow' : ''],
        attrs: {
          "tabindex": _vm.ariaInsideNoticeFocus.all ? 1 : undefined
        },
        on: {
          "click": _vm.$_click
        }
      }, [_c('div', {
        staticClass: "nx-notice-bar-left",
        attrs: {
          "aria-hidden": "true"
        }
      }, [_vm.customLeft ? [_vm._t("left")] : _vm.icon ? [_c('nx-icon', {
        staticClass: "icon",
        attrs: {
          "name": _vm.leftIcon
        }
      })] : _vm._e()], 2), _c('div', {
        ref: "wrap",
        staticClass: "nx-notice-bar-content",
        attrs: {
          "tabindex": _vm.ariaInsideNoticeFocus.middle ? 1 : undefined
        }
      }, [_c('div', {
        ref: "content",
        staticClass: "nx-notice-bar-content-text",
        style: _vm.overflow && _vm.scrollable && _vm.$_contentStyle(),
        on: {
          "transitionend": _vm.$_onTransitionEnd
        }
      }, [_vm._t("default"), _vm.single ? [_c('span', {
        style: {
          width: _vm.singleWidth + 'px',
          display: 'inline-block'
        }
      }), _vm._t("default"), _c('span', {
        style: {
          width: _vm.singleWidth + 'px',
          display: 'inline-block'
        }
      })] : _vm._e()], 2)]), _vm.mode ? _c('div', {
        staticClass: "nx-notice-bar-right"
      }, [_vm.customRight ? [_vm._t("right")] : _vm.mode || _vm.closable ? [_c('nx-icon', {
        staticClass: "icon",
        attrs: {
          "name": _vm.rightIcon,
          "aria-hidden": !_vm.ariaInsideNoticeFocus.right,
          "role": "button",
          "aria-label": this.mode === 'link' ? '箭头' : '关闭'
        },
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.$_close($event);
          }
        }
      })] : _vm._e()], 2) : _vm._e()]) : _vm._e()]);
    },
    name: 'nx-notice-bar',
    components: (0, _defineProperty2.default)({}, _icon.default.name, _icon.default),
    props: {
      value: {
        type: Boolean
      },
      mode: {
        type: String,
        default: '' // closeable, link

      },
      type: {
        type: String,
        default: 'default' // default, warning

      },
      align: {
        type: String,
        default: 'left'
      },
      time: {
        type: Number,
        default: 0
      },
      scrollable: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: 'notice' // notice, safe

      },
      delay: {
        type: Number,
        default: 1000
      },
      speed: {
        type: Number,
        default: 50
      },
      ariaNoticeFocus: {
        type: Object,
        default: function _default() {
          return {
            all: false,
            middle: true,
            right: true
          };
        }
      },
      single: {
        type: Boolean,
        default: false
      },
      singleWidth: {
        type: Number,
        default: 50
      }
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    data: function data() {
      var _this$$options$propsD;

      return {
        isShow: (_this$$options$propsD = this.$options.propsData.value) !== null && _this$$options$propsD !== void 0 ? _this$$options$propsD : true,
        overflow: false,
        offset: 0,
        duration: 0
      };
    },
    computed: {
      customLeft: function customLeft() {
        return !!this.$slots.left;
      },
      customRight: function customRight() {
        return !!this.$slots.right;
      },
      leftIcon: function leftIcon() {
        return this.icon === 'notice' ? 'notice-sound' : 'notice-safety';
      },
      rightIcon: function rightIcon() {
        return this.mode === 'link' ? 'notice-right-arrow' : 'notice-close';
      },
      ariaInsideNoticeFocus: function ariaInsideNoticeFocus() {
        var _this$ariaNoticeFocus = this.ariaNoticeFocus,
            _this$ariaNoticeFocus2 = _this$ariaNoticeFocus.all,
            all = _this$ariaNoticeFocus2 === void 0 ? true : _this$ariaNoticeFocus2,
            _this$ariaNoticeFocus3 = _this$ariaNoticeFocus.middle,
            middle = _this$ariaNoticeFocus3 === void 0 ? false : _this$ariaNoticeFocus3,
            _this$ariaNoticeFocus4 = _this$ariaNoticeFocus.right,
            right = _this$ariaNoticeFocus4 === void 0 ? false : _this$ariaNoticeFocus4;
        return {
          all: all,
          middle: middle,
          right: right
        };
      }
    },
    watch: {
      value: function value(val) {
        this.isShow = val;
      }
    },
    mounted: function mounted() {
      if (this.time) {
        this.$_hide(this.time);
      }

      this.$_checkOverflow();
    },
    activated: function activated() {
      this.$_checkOverflow();
    },
    methods: {
      checkModel: function checkModel() {
        return Object.prototype.hasOwnProperty.call(this.$options.propsData, 'value');
      },
      reset: function reset() {
        this.offset = 0;
        this.duration = 0;
        this.wrapWidth = 0;
        this.contentWidth = 0;
      },
      $_hide: function $_hide(time) {
        var _this = this;

        setTimeout(function () {
          if (_this.checkModel()) {
            _this.$emit('input', false);
          } else {
            _this.isShow = false;
          }
        }, time);
      },
      $_checkOverflow: function $_checkOverflow() {
        var _this2 = this;

        if (!this.scrollable) {
          return;
        }

        var _this$$refs = this.$refs,
            wrap = _this$$refs.wrap,
            content = _this$$refs.content;
        /* istanbul ignore if */

        if (!wrap || !content) {
          return;
        }

        this.reset();
        clearTimeout(this.startTimer);
        this.startTimer = setTimeout(function () {
          var wrapWidth = wrap.clientWidth;
          var contentWidth = content.scrollWidth;
          _this2.overflow = contentWidth > wrapWidth;
          (0, _raf.doubleRaf)(function () {
            _this2.offset = -contentWidth;
            _this2.duration = contentWidth / _this2.speed;
            _this2.wrapWidth = wrapWidth;
            _this2.contentWidth = contentWidth;
          });
        }, this.delay);
      },
      $_contentStyle: function $_contentStyle() {
        return {
          transform: this.offset ? "translateX(".concat(this.single ? this.offset / 2 : this.offset, "px)") : '',
          transitionDuration: (!this.single ? this.duration : this.duration / 2) + 's'
        };
      },
      $_onTransitionEnd: function $_onTransitionEnd() {
        var _this3 = this;

        if (this.single) {
          this.offset = 0;
          this.duration = 0;
          (0, _raf.raf)(function () {
            (0, _raf.doubleRaf)(function () {
              _this3.offset = -_this3.contentWidth;
              _this3.duration = _this3.contentWidth / _this3.speed;
            });
          });
        } else {
          this.offset = this.wrapWidth;
          this.duration = 0;
          (0, _raf.raf)(function () {
            (0, _raf.doubleRaf)(function () {
              _this3.offset = -_this3.contentWidth;
              _this3.duration = (_this3.contentWidth + _this3.wrapWidth) / _this3.speed;
            });
          });
        }
      },
      $_close: function $_close() {
        if (this.mode === 'closable') {
          if (this.checkModel()) {
            this.$emit('input', false);
          } else {
            this.isShow = false;
          }

          this.$emit('close');
        } else {
          this.$emit('click');
        }
      },
      $_click: function $_click() {
        this.$emit('click');
      }
    }
  };
  _exports.default = _default2;
});